import axiosInstance from '@/utils/request'

export const post = (url, data = {}, config = { disableToken: false }) => {
  const instanceConfig = config.disableToken
    ? {
        url,
        headers: {
          isToken: false,
        },
        method: 'post',
        data,
      }
    : {
        url,
        method: 'post',
        data,
      }

  return axiosInstance(instanceConfig)
}

export const get = (url, params = {}, config = { disableToken: false }) => {
  const instanceConfig = config.disableToken
    ? {
        url,
        headers: {
          isToken: false,
        },
        method: 'get',
        params,
      }
    : {
        url,
        method: 'get',
        params,
      }

  return axiosInstance(instanceConfig)
}

export const asyncPost = (url, data, config) => {
  return post(url, data, config)
    .then((res) => [null, res])
    .catch((err) => [err])
}

export const asyncGet = (url, data, config) => {
  return get(url, data, config)
    .then((res) => [null, res])
    .catch((err) => [err])
}
